import { useState, useEffect } from "react";

export const MEDIA_SIZES = {
  desktop: "desktop",
  tablet: "tablet",
  smartphone: "smartphone",
  phone: "phone",
};

export const MEDIA_QUERIES = {
  queryList: [
    { query: "(min-width: 992px)", value: MEDIA_SIZES.desktop },
    { query: "(min-width: 768px)", value: MEDIA_SIZES.tablet },
    { query: "(min-width: 576px)", value: MEDIA_SIZES.smartphone },
    { query: "(max-width: 576px) ", value: MEDIA_SIZES.smartphone },
  ],
  defaultValue: MEDIA_SIZES.desktop,
};

/**
 * Отслеживает список mediaQuery.
 * @param {Object[]} queries массив запросов
 * @param {String} queries[].query строка mediaQuery.
 * @param {String} queries[].value значение, возвращаемое при совпадении указанной mediaQuery
 * @param {String} defaultValue значение, возвращаемое когда нет совпадений с какой-либо из mediaQuery
 * @returns {String} возвращает value mediaQuery с которой первым произошло совпадение, иначе defaultValue
 * @component
 */
function useMediaQuery(queries, defaultValue) {
  const mediaQueryLists = queries.map((query) =>
    window.matchMedia(query.query)
  );

  const [value, setValue] = useState(getValue);

  function getValue() {
    const index = mediaQueryLists.findIndex(
      (mediaQueryList) => mediaQueryList.matches
    );

    return typeof queries[index] !== "undefined"
      ? queries[index].value
      : defaultValue;
  }

  useEffect(() => {
    const handler = () => setValue(getValue);
    mediaQueryLists.forEach((mediaQueryList) => {
      /* Эта конструкция нужна, на 14.12.2021, потому-что на актуальном safari 
      под ios метод addEventListener у mediaqueryList просто отсутствует, не смотря на то
      что на данный момент addlistener уже некоторое время deprecated и в случаях тестирования
      на safari (macos), mozilla firefox (все платформы) и google chrome (все платформы) 
      addeventlistener работает без проблем. Данный кусок кода, вероятно,  покроет и прочие случаи когда
      addeventlistener отсутствует, но присутствует устаревший addlistener.
      https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList
       */
      if (mediaQueryList?.addEventListener) {
        mediaQueryList.addEventListener("change", handler);
      } else {
        if (mediaQueryList?.addListener) {
          mediaQueryList.addListener(handler);
        }
      }
    });
    return () =>
      mediaQueryLists.forEach((mediaQueryList) => {
        if (mediaQueryList?.removeEventListener) {
          mediaQueryList.removeEventListener("change", handler);
        } else {
          if (mediaQueryList?.removeListener) {
            mediaQueryList.removeListener(handler);
          }
        }
      });
  }, []);

  return value;
}

export default useMediaQuery;
